import { useTranslation } from 'react-i18next'
import {
	Wrapper,
	ContentWrapper,
	Monogram,
	TitleImage,
	Title,
	HeroAction,
	EnterWebsite,
	EnterWebsiteContent,
	Icon,
} from './styles'

function Hero() {
	const { t } = useTranslation()

	const handleEnterSite = () => {
		document.getElementById('intro').scrollIntoView({ behavior: 'smooth' })
	}

	return (
		<Wrapper id="hero">
			<ContentWrapper>
				<Monogram />
				<TitleImage />
				<Title>Thais & Elton</Title>
			</ContentWrapper>
			<HeroAction>
				<EnterWebsite type="button" onClick={handleEnterSite}>
					<EnterWebsiteContent>
						{t('Entre no Site')}
						<Icon className="fa fa-angle-double-down" />
					</EnterWebsiteContent>
				</EnterWebsite>
			</HeroAction>
		</Wrapper>
	)
}

export default Hero
